export const ACTIVE_ITEM_WIDTH_PERCENT = 50;
export const SNAPPING_INTERVAL_FAKE_ITEM = 'SNAPPING_INTERVAL_FAKE_ITEM';
